import { NavItemEnum } from '../../../constants/routing/NavItems';
import { UseCaseGroupEnum, useCasesQueryParamKey } from './useCaseConstants';
export const getUseCasesByPage = page => {
  switch (page) {
    case NavItemEnum.SMART_CRM:
    case NavItemEnum.SALES:
    case NavItemEnum.DATA:
    case NavItemEnum.COMMERCE:
    case NavItemEnum.FREE:
      return [UseCaseGroupEnum.SALES];
    case NavItemEnum.SERVICE:
      return [UseCaseGroupEnum.SERVICE];
    case NavItemEnum.SUITE:
      return [UseCaseGroupEnum.MARKETING, UseCaseGroupEnum.SALES, UseCaseGroupEnum.SERVICE];
    case NavItemEnum.MARKETING:
    case NavItemEnum.CONTENT:
    case NavItemEnum.MARKETING_PLUS:
    case NavItemEnum.HUBSPOT_CREDITS:
    case NavItemEnum.BUNDLE:
    default:
      return [UseCaseGroupEnum.MARKETING];
  }
};
export const getUseCaseGroupsFromQueryParams = searchParams => {
  const searchParamsObj = typeof searchParams === 'string' ? new URLSearchParams(searchParams) : searchParams;
  return searchParamsObj.getAll(useCasesQueryParamKey);
};
export const getValidatedUseCaseGroups = (useCases, availableUseCases) => {
  const validUseCases = useCases.map(useCase => useCase.toUpperCase()).filter(useCase => availableUseCases.some(uc => uc === useCase));
  return [...new Set(validUseCases)];
};